module.exports = __webpack_public_path__ + "img/20210610-IMG_0933.4afeaae2.jpg";